/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EmailSignatureCreateTemplateKey = typeof EmailSignatureCreateTemplateKey[keyof typeof EmailSignatureCreateTemplateKey] | null;


export const EmailSignatureCreateTemplateKey = {
  sidebar: 'sidebar',
  stacked: 'stacked',
  banner: 'banner',
} as const;
